import styled, { css } from 'styled-components'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { SecondaryButton } from '@chegg/fanta'
import { SpecialOutlineButton } from '@chegg-wt/core/theme/fanta/button'
import { font, colors, spacing, ExportIcon, ChevronIcon } from '@chegg-ui/theme'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const CitationStyleButton = styled(SpecialOutlineButton)`
  &&& {
    padding: 8px 14px;
  }
  > span {
    font-size: ${font.size.px20};
  }
`

export const ButtonText = styled.div`
  max-width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const ImageWrapper = styled.div``

const imageWrapperCss = css`
  transition: background-color 0.3s ease-in;
  padding: ${spacing.px4} ${spacing.px8};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CopyImage = styled.div`
  background-image: ${`url('${publicAssetUrl('copy.svg')}');`};
  width: 20px;
  height: 24px;
`

export const CopyButton = styled(SecondaryButton)`
  font-size: ${font.size.px18};
  color: ${colors.dark};
  padding-left: 0;
  padding-right: 0;

  ${ImageWrapper} {
    ${imageWrapperCss}
  }

  &:hover {
    ${ImageWrapper} {
      background-color: ${colors.skyLight};
    }
  }
`
export const ExportButton = styled(SecondaryButton)`
  font-size: ${font.size.px18};
  color: ${colors.dark};
  padding-right: 0;
  padding-left: 0;
  margin-left: ${spacing.px12};

  ${ImageWrapper} {
    ${imageWrapperCss}
  }

  &:hover {
    ${ImageWrapper} {
      background-color: ${colors.skyLight};
    }
  }

  @media (max-width: ${({ theme }) => themeBreakPoints.medium(theme)}) {
    padding: 0;
    margin: 0;
  }
`

export const Chevron = styled(ChevronIcon)`
  margin-left: ${spacing.px4};
`

export const Export = styled(ExportIcon)`
  margin-right: ${spacing.px4};
`

export const CitationCTAContainer = styled.div`
  display: flex;
  padding-bottom: ${spacing.px32};
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${({ theme }) => themeBreakPoints.large(theme)}) {
    flex-wrap: wrap;
    padding-bottom: ${spacing.px16};
  }

  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    flex-direction: column;
    align-items: center;
  }
`
export const CitationButtonCTAContainer = styled.div`
  display: flex;

  > div,
  > button {
    padding: 0 ${spacing.px12};
  }

  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    flex-direction: column;
    align-items: center;

    > div > button,
    > button {
      width: 400px;
    }
    && > button {
      padding: ${spacing.px12} ${spacing.px32};
    }
    > div {
      padding: ${spacing.px12} 0;
    }
  }

  @media (max-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    width: 100%;
    > div > button,
    > button {
      width: 100%;
    }
    > div {
      width: 100%;
    }
  }
`
export const CitationUtilityCTAContainer = styled.div`
  display: flex;
  @media (max-width: ${({ theme }) => themeBreakPoints.medium(theme)}) {
    margin-top: ${spacing.px12};
  }

  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    flex-direction: column;
    margin-top: 0;
  }
`
